import Heros from './components/Heros';
import NavBar from './components/NavBar';
import Techs from './components/Techs';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Projects } from "./components/Projects";
import AboutMe from './components/AboutMe';
import ComingSoon from './components/ComingSoon';
import ContactForm from './components/Contact';
import './App.css';

function App() {
  return (
    <Router>
      <NavBar /> {/* Place NavBar outside the routes for consistent navigation */}
      <Routes>
        {/* Define all routeable components */}
        <Route path="/" element={
            <>
              <div id="hero">
                <Heros />
              </div>
              <div id="About">
                <AboutMe />
              </div>
              <div id="Techs">
                <Techs/>
              </div>
              <div id="Projects">
                <Projects />
              </div>
              <div id="Contact">
                <ContactForm />
              </div>
              
            </>
          } />
        <Route path="/coming-soon" element={<ComingSoon />} />
      </Routes>
    </Router>
  );
}

export default App;
